import React from 'react';
import { withStyles, Typography } from '@material-ui/core';
import qs from 'query-string';
import ContentHeader from '../components/ContentHeader';
import ViewTicketButtons from '../components/ViewTicketButtons';
import ButtonLink from '../components/ButtonLink';

const styles = theme => ({
    root: {
        textAlign: 'center',
        border: '0',
        maxWidth: '800px',
        margin: '40px auto',
        position: 'relative',
        background: '#fff',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.21)',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    heading: {
        marginBottom: '10px'
    },
    subheading: {
        marginTop: '20px'
    },
    paragraph: {
        fontSize: '16px',
        marginBottom: '10px',
        fontWeight: '100'
    },
    inner: {
        padding: '20px 10px'
    },
    button: {
        margin: '5px 5px'
    }
});

const AdhocOrderConfirmed = ({ classes, match, location }) => {
    const {
        params: {
            customerTicketId,
            year,
            clientSlug,
            serviceId,
            ticketId,
            clientId
        }
    } = match;

    const query = qs.parse(location.search);
    const isFixed = query.is_fixed || false;

    const hideBuyAgain = ['4338dc60-3dc5-45eb-98b5-426581ac1e17'];

    const showBuyAgain =
        year &&
        clientId &&
        serviceId &&
        ticketId &&
        !isFixed &&
        !hideBuyAgain.includes(clientId);

    return (
        <div className={classes.root}>
            <ContentHeader
                text="Order Confirmed"
                id="order-confirmed-heading"
            />
            <div className={classes.inner}>
                <Typography className={classes.paragraph} variant="body2">
                    Congratulations, your order was successful and your ticket
                    is ready to use.
                </Typography>
                {showBuyAgain && (
                    <Typography className={classes.paragraph} variant="body2">
                        <ButtonLink
                            className={classes.button}
                            variant="outlined"
                            color="primary"
                            to={`/buy-again/${year}/${clientId}/${serviceId}/${ticketId}/${customerTicketId}`}
                        >
                            Buy again
                        </ButtonLink>
                    </Typography>
                )}
                {year && clientSlug && serviceId && ticketId && (
                    <Typography className={classes.paragraph} variant="body2">
                        <ButtonLink
                            className={classes.button}
                            variant="outlined"
                            color="primary"
                            to={`/create-ticket/${year}/${clientSlug}/${serviceId}/${ticketId}`}
                        >
                            Buy for another passenger
                        </ButtonLink>
                    </Typography>
                )}
                <Typography className={classes.paragraph} variant="body2">
                    Tickets will be scanned on board and will need to be
                    presented by the passenger.
                </Typography>

                <ViewTicketButtons ticketId={customerTicketId} />
            </div>
        </div>
    );
};

export default withStyles(styles)(AdhocOrderConfirmed);
